module.exports = __webpack_public_path__ + "media/images/action_down-ab43839083d938053f6ae517d31e1e68.png";